const updateMigrationPassword: any = {
  header: "Choose a new password",
  description:
    "Due to updated password requirements, please set a new password. You'll use this going forward when you log in as <strong>{{email}}</strong>.",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmNewPassword: "Confirm new password",
  saveAndFinish: "Save and finish",
  errors: {
    lengthError: "New password must be at least 8 characters",
    notMatchError: "The passwords you entered do not match.",
  },
};

export { updateMigrationPassword };
